<template>
    <div class="post-tag-wrap" v-if="item!==null && item.tags!==null && item.tags.length>0">
        <span class="post-tag" v-for="tag in item.tags"> 
        {{tag.child.name }}
        </span>
    </div>
</template>
<script>
export default {
    props: {
        item: { type: Object, default: null }
    },
    data: function () {
        return {

        };
    },
    computed: {

    },
    methods: {

    },
    created: function () {

    },
    destroyed: function () {

    },
    mounted: function () {

    }
}
</script>